// extracted by mini-css-extract-plugin
export var container = "_g2-0";
export var content = "_g2-3";
export var customerTitle = "_g2-4";
export var empty = "_g2-5";
export var gray = "_g2-6";
export var header = "_g2-7";
export var info = "_g2-8";
export var loading = "_g2-2";
export var loadingCard = "_g2-9";
export var oneLine = "_g2-a";
export var personName = "_g2-e";
export var pillContainer = "_g2-b";
export var selected = "_g2-1";
export var text = "_g2-c";
export var twoLines = "_g2-d";
export var unread = "_g2-f";
export var unreadIndicator = "_g2-g";